<template>
  <div class="group-result">
    <result-head type="success">报名成功！</result-head>
    <group-result-main :qrCode="qrCode"></group-result-main>
  </div>
</template>

<script>
import keys from 'lodash.keys'
import module from '../modules/group-result'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import ResultHead from '../components/Result/ResultHead.vue'
import GroupResultMain from '../components/GroupResultMain.vue'

export default {
  computed: {
    ...mapState(module.name, keys(module.state)),
    ...mapGetters(module.name, keys(module.getters))
  },
  methods: {
    ...mapMutations(module.name, keys(module.mutations)),
    ...mapActions(module.name, keys(module.actions))
  },
  beforeCreate () {
    this.$store.registerModule(module.name, module)
  },
  created () {
    this.init()
  },
  beforeDestroy () {
    this.$store.unregisterModule(module.name)
  },
  components: {
    ResultHead,
    GroupResultMain
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../style/main";

.group-result {}
</style>
